jQuery(document).ready(function ($) {
    document.cookie = "atk_signup=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.activtrak.com";
    $("#btn-signup").on("click", function (e) {
        e.preventDefault();

        var email = $('.promo-banner__actions input[type=email]').val();
        var $this = $(this);
        $("#signup-validation-msg").css("display", "none");
        $("#signup-banner-input").removeClass("empty-input");

        $this.prev().removeClass("error");

        if (window.innerWidth <= 992) {
            window.location.href = "https://signup.activtrak.com/";
            return;
        }

        if (!email) {
            $("#signup-validation-msg").css("display", "block");
            $("#signup-banner-input").addClass("empty-input");
            $this.prev().addClass("error");
            return;
        }


        function setCookie(name, value, days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/; domain=.activtrak.com";
        }


        var data = {
            action: "validate_business_email",
            email: email,
        };

        $.ajax({
            url: at_ajaxurl,
            data: data,
            type: "POST",
            beforeSend: function () {
                $this.prev().val("Validating...");
                $this.prop("disabled", true);
                $this.prev().prop("disabled", true);
            },
            complete: function () {
                $this.prop("disabled", false);
                $this.prev().prop("disabled", false);
                $this.prev().val(email);
            },
            success: function () {
                var expires = new Date();
                expires.setMonth(expires.getMonth() + 12);
                var signup_cookie =
                    "atk_signup=" +
                    btoa(email) +
                    ";expires=" +
                    expires.toUTCString() +
                    ";domain=.activtrak.com;path=/";

                var form = MktoForms2 && (MktoForms2.getForm(1510) || MktoForms2.getForm(1819));
                if (Cookie.get("country") === "US" && form) {
                    form.vals({Email: email});
                    form.onSuccess(function () {
                        document.cookie = signup_cookie;
                        window.location.href = "https://signup.activtrak.com/";
                        return false;
                    });
                    form.submit();
                } else {
                    document.cookie = signup_cookie;
                    window.location.href = "https://signup.activtrak.com/";
                }
            },
            error: function () {
                $("#signup-validation-msg").css("display", "block");
                $("#signup-banner-input").addClass("empty-input");
                $this.prev().addClass("error");
            },
        });
    });
});
jQuery(document).ready(function ($) {
    document.cookie = "atk_signup=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.activtrak.com";
    window.localStorage.removeItem("email");

    $("#btn-demo").on("click", function (e) {
        e.preventDefault();
        var email = $('.promo-banner__actions input[type=email]').val();
        var $this = $(this);
        $("#signup-validation-msg").css("display", "none");
        $("#signup-banner-input").removeClass("empty-input");

        $this.prev().removeClass("error");

        if (window.innerWidth <= 992) {
            window.location.href = window.location.origin + "/demo-request/";
            return;
        }

        if (!email) {
            $("#signup-validation-msg").css("display", "block");
            $("#signup-banner-input").addClass("empty-input");
            $this.prev().addClass("error");
            return;
        }

        function setCookie(name, value, days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/; domain=.activtrak.com";
        }


        var data = {
            action: "validate_business_email",
            email: email,
        };

        $.ajax({
            url: at_ajaxurl,
            data: data,
            type: "POST",
            beforeSend: function () {
                $this.prev().val("Validating...");
                $this.prop("disabled", true);
                $this.prev().prop("disabled", true);
            },
            complete: function () {
                $this.prop("disabled", false);
                $this.prev().prop("disabled", false);
                $this.prev().val(email);
            },
            success: function () {
                window.localStorage.setItem("email", email);
                var expires = new Date();
                expires.setMonth(expires.getMonth() + 12);
                var signup_cookie =
                    "atk_signup=" +
                    btoa(email) +
                    ";expires=" +
                    expires.toUTCString() +
                    ";domain=.activtrak.com;path=/";

                var form = MktoForms2 && (MktoForms2.getForm(1510));
                if (Cookie.get("country") === "US" && form) {
                    form.vals({Email: email});
                    form.onSuccess(function () {
                        document.cookie = signup_cookie;
                        window.location.href = window.location.origin + "/demo-request/";
                        return false;
                    });
                    form.submit();
                } else {
                    document.cookie = signup_cookie;
                    window.location.href = window.location.origin + "/demo-request/";
                }
            },
            error: function () {
                $("#signup-validation-msg").css("display", "block");
                $("#signup-banner-input").addClass("empty-input");
                $this.prev().addClass("error");
            },
        });
    });
});
